// src/components/NFe/SimpleNFeViewer.js
import React, { useState } from 'react';
import axios from 'axios';
import './SimpleNFeViewer.css';

const SimpleNFeViewer = () => {
  const [chaveDeAcesso, setChaveDeAcesso] = useState('');
  const [xmlContent, setXmlContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const buscarNFe = async () => {
    // Validação básica - verifica se tem 44 dígitos numéricos
    if (!/^\d{44}$/.test(chaveDeAcesso.trim())) {
      setError('Chave de acesso inválida. Deve conter 44 dígitos numéricos.');
      return;
    }

    setLoading(true);
    setError('');
    setXmlContent('');

    try {
      // Usando a mesma URL e configuração do arquivo buscarNFe.js
      const url = `https://ws.meudanfe.com/api/v1/get/nfe/xml/${chaveDeAcesso.trim()}`;
      const body = 'empty';
      const headers = {
        'Referer': 'https://danferapida.com.br/',
        'Content-Type': 'text/plain;charset=UTF-8'
      };

      const response = await axios.post(url, body, { headers });
      
      // Salva o XML recebido
      setXmlContent(response.data);
    } catch (error) {
      // Tratamento de erro similar ao buscarNFe.js
      if (error.response && error.response.status === 400) {
        // Contingência - algumas vezes a API retorna 400 mas com o XML correto
        setXmlContent(error.response.data);
      } else {
        setError(
          error.response 
            ? `Erro ${error.response.status}: ${error.response.data}` 
            : `Erro: ${error.message}`
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarNFe();
    }
  };

  const copiarXml = () => {
    navigator.clipboard.writeText(xmlContent)
      .then(() => alert('XML copiado para a área de transferência!'))
      .catch(err => console.error('Erro ao copiar: ', err));
  };

  return (
    <div className="simple-nfe-container">
      <h2>Visualizador de XML de NFe</h2>
      
      <div className="simple-nfe-input-group">
        <input
          type="text"
          placeholder="Digite a chave de acesso da NFe (44 dígitos)"
          value={chaveDeAcesso}
          onChange={(e) => setChaveDeAcesso(e.target.value)}
          onKeyPress={handleKeyPress}
          className="simple-nfe-input"
          maxLength="44"
        />
        <button 
          onClick={buscarNFe} 
          disabled={loading} 
          className="simple-nfe-button"
        >
          {loading ? 'Buscando...' : 'Buscar NFe'}
        </button>
      </div>
      
      {error && (
        <div className="simple-nfe-error">
          {error}
        </div>
      )}

      {xmlContent && (
        <div className="simple-nfe-result">
          <div className="simple-nfe-header">
            <h3>XML Recebido</h3>
            <button onClick={copiarXml} className="simple-nfe-copy-button">
              Copiar XML
            </button>
          </div>
          <div className="simple-nfe-xml-header">--- CONTEÚDO XML RECEBIDO ---</div>
          <pre className="simple-nfe-xml">{xmlContent}</pre>
          <div className="simple-nfe-xml-footer">---------------------------------</div>
        </div>
      )}
    </div>
  );
};

export default SimpleNFeViewer;